<template>
  <div id="bg-image">
    <alert-response-page />
  </div>
</template>

  <script>
  import AlertResponsePage from '../../AlertResponsePage.vue';
    export default {
      name: 'AlertMarkSafe',
      components: {
        AlertResponsePage,
      },
    };
  </script>
